


export const tableItems=[
   
        {
        Piece:5 ,
        Pus:  34 ,
        Fine:10,
        Year:2005,
        Hive:"34/28/14",
        BrandN:"Pailung",
        Kind:"Süprem"
        },
        {
        Piece:4 ,
        Pus: 34 ,
        Fine:10,
        Year:2014,
        Hive:"34/28 - 34/14",
        BrandN:"Kervan",
        Kind:"Süprem"
        },
        {
        Piece:1 ,
        Pus:  34 ,
        Fine:10,
        Year:2006,
        Hive:"34/28 - 34/22",
        BrandN:"Orizio",
        Kind:"Süprem"
        },
        {
        Piece:1 ,
        Pus:  32 ,
        Fine:10,
        Year:2008,
        Hive:"34/22",
        BrandN:"Jin General",
        Kind:"Süprem"
        },
        {
        Piece:4 ,
        Pus:  32 ,
        Fine:12,
        Year:2021,
        Hive:"",
        BrandN:"Honji",
        Kind:"Süprem"
        },
        {
        Piece:6 ,
        Pus:  32 ,
        Fine:28,
        Year:2021,
        Hive:"",
        BrandN:"Honji",
        Kind:"3 İplik"
        },
        {
        Piece:5 ,
        Pus: 32 ,
        Fine:12,
        Year:2005,
        Hive:"",
        BrandN:"Mayer",
        Kind:"Ribana"
        },
        {
        Piece:2 ,
        Pus: 36 ,
        Fine:17,
        Year:2021,
        Hive:"",
        BrandN:"Honji",
        Kind:"Ribana"
        },

]